export default "__VITE_ASSET__rKUKyo6j__"